import { render, staticRenderFns } from "./order3.vue?vue&type=template&id=2846c193&scoped=true"
import script from "./order3.vue?vue&type=script&lang=js"
export * from "./order3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2846c193",
  null
  
)

export default component.exports